var _rect, _text, _text2, _text3, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessFlow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1700,
    height: 2280,
    viewBox: "0 0 1700 2280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1700,
    height: 2280,
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 56,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#C4661E",
    letterSpacing: 2
  }, "ACME PR INTELLIGENCE  \xB7  USER WORKFLOW")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 100,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 34,
    fontWeight: 700,
    fill: "#152451"
  }, "A coordinator's day \u2014 from login to end of day.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 126,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fill: "#727891"
  }, "Morning triage on the Hot Board, ongoing dispatch and tracking on the Watch List. Decisions branch; the system follows.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,180)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1604,
    height: 48,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 6,
    height: 48,
    rx: 3,
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 30,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#934D17",
    letterSpacing: 1.5
  }, "PHASE 1  \xB7  MORNING TRIAGE  \xB7  8:00 AM TO 11:00 AM"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,260)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 0,
    width: 320,
    height: 80,
    rx: 12,
    fill: "#152451",
    stroke: "#152451",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 34,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "Login to Pulse"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 58,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C5CAD9",
    textAnchor: "middle"
  }, "SSO, RBAC-gated, lands on Hot Board"), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 86,
    x2: 800,
    y2: 116,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800,124 794,116 806,116",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 130,
    width: 320,
    height: 80,
    rx: 12,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 130,
    width: 6,
    height: 80,
    rx: 3,
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 164,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#934D17",
    textAnchor: "middle"
  }, "Land on Hot Board"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 188,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E",
    textAnchor: "middle"
  }, "5\u20138 stories scored, drafted, ready"), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 216,
    x2: 800,
    y2: 246,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800,254 794,246 806,246",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 260,
    width: 320,
    height: 100,
    rx: 12,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 260,
    width: 6,
    height: 100,
    rx: 3,
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 294,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#934D17",
    textAnchor: "middle"
  }, "Pick top story"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 316,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E",
    textAnchor: "middle"
  }, "Highest score first \u2014 the system has"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 334,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E",
    textAnchor: "middle"
  }, "already triaged the queue"), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 366,
    x2: 800,
    y2: 396,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800,404 794,396 806,396",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 410,
    width: 400,
    height: 120,
    rx: 12,
    fill: "#E6F4FB",
    stroke: "#8AC6E7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 410,
    width: 6,
    height: 120,
    rx: 3,
    fill: "#0093CF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 444,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#00597C",
    textAnchor: "middle"
  }, "Review the card"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 466,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#0076A6",
    textAnchor: "middle"
  }, "Article context \xB7 Expert match + reason"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 484,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#0076A6",
    textAnchor: "middle"
  }, "Reporter match + CRM state \xB7 Drafted pitch"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 510,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 500,
    fontStyle: "italic",
    fill: "#0076A6",
    textAnchor: "middle"
  }, "\"Should I send this?\""), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 536,
    x2: 800,
    y2: 566,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800,574 794,566 806,566",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800,580 920,640 800,700 680,640",
    fill: "#FFFBE6",
    stroke: "#FFEC85",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 636,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#998400",
    textAnchor: "middle"
  }, "Decision"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 658,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#998400",
    textAnchor: "middle"
  }, "Send / Edit / Defer / Reject"), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 640,
    x2: 240,
    y2: 640,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 640,
    x2: 240,
    y2: 780,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240,788 234,780 246,780",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 700,
    x2: 800,
    y2: 780,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800,788 794,780 806,780",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 640,
    x2: 1360,
    y2: 640,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 640,
    x2: 1360,
    y2: 780,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1360,788 1354,780 1366,780",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 630,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#5A5F73"
  }, "looks good"), /*#__PURE__*/React.createElement("text", {
    x: 816,
    y: 630,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#5A5F73"
  }, "needs tweaks"), /*#__PURE__*/React.createElement("text", {
    x: 1180,
    y: 630,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#5A5F73"
  }, "not now / no"), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 790,
    width: 320,
    height: 100,
    rx: 12,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 790,
    width: 6,
    height: 100,
    rx: 3,
    fill: "#009391"
  }), /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 824,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#005A58",
    textAnchor: "middle"
  }, "Send"), /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 846,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674",
    textAnchor: "middle"
  }, "Pitch dispatched via Outlook"), /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 864,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674",
    textAnchor: "middle"
  }, "Status flips to \"sent\""), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 790,
    width: 320,
    height: 100,
    rx: 12,
    fill: "#E6F4FB",
    stroke: "#8AC6E7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 790,
    width: 6,
    height: 100,
    rx: 3,
    fill: "#0093CF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 824,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#00597C",
    textAnchor: "middle"
  }, "Edit pitch"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 846,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#0076A6",
    textAnchor: "middle"
  }, "Inline edit, diff captured"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 864,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#0076A6",
    textAnchor: "middle"
  }, "as a learning event"), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 790,
    width: 320,
    height: 100,
    rx: 12,
    fill: "#FDE7EE",
    stroke: "#F68BAA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 790,
    width: 6,
    height: 100,
    rx: 3,
    fill: "#ED145B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1360,
    y: 824,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#8E0C37",
    textAnchor: "middle"
  }, "Defer or Reject"), /*#__PURE__*/React.createElement("text", {
    x: 1360,
    y: 846,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#BE1049",
    textAnchor: "middle"
  }, "Defer = revisit tomorrow"), /*#__PURE__*/React.createElement("text", {
    x: 1360,
    y: 864,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#BE1049",
    textAnchor: "middle"
  }, "Reject = trains the matcher"), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 896,
    x2: 800,
    y2: 930,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 890,
    x2: 240,
    y2: 930,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 930,
    x2: 800,
    y2: 930,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 890,
    x2: 1360,
    y2: 930,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 930,
    x2: 1360,
    y2: 930,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 930,
    x2: 800,
    y2: 960,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800,968 794,960 806,960",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 970,
    width: 320,
    height: 80,
    rx: 12,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 970,
    width: 6,
    height: 80,
    rx: 3,
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 1004,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#934D17",
    textAnchor: "middle"
  }, "Next story"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 1028,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E",
    textAnchor: "middle"
  }, "Repeat for each card on the board"), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 1056,
    x2: 800,
    y2: 1086,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800,1094 794,1086 806,1086",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 1100,
    width: 400,
    height: 80,
    rx: 12,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 1100,
    width: 6,
    height: 80,
    rx: 3,
    fill: "#92278F"
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 1134,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#581756",
    textAnchor: "middle"
  }, "Hot Board cleared"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 1158,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73",
    textAnchor: "middle"
  }, "All overnight stories triaged \u2014 ready to switch tabs"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,1500)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1604,
    height: 48,
    rx: 10,
    fill: "#E6F4FB",
    stroke: "#8AC6E7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 6,
    height: 48,
    rx: 3,
    fill: "#0093CF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 30,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#00597C",
    letterSpacing: 1.5
  }, "PHASE 2  \xB7  ONGOING DISPATCH AND TRACKING  \xB7  11:00 AM TO END OF DAY"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,1580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 0,
    width: 320,
    height: 80,
    rx: 12,
    fill: "#E6F4FB",
    stroke: "#8AC6E7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 0,
    width: 6,
    height: 80,
    rx: 3,
    fill: "#0093CF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 34,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#00597C",
    textAnchor: "middle"
  }, "Switch to Watch List"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 58,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#0076A6",
    textAnchor: "middle"
  }, "Pitches in flight, sorted by status"), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 0,
    width: 320,
    height: 80,
    rx: 12,
    fill: "#E6F4FB",
    stroke: "#8AC6E7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 0,
    width: 6,
    height: 80,
    rx: 3,
    fill: "#0093CF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 34,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#00597C",
    textAnchor: "middle"
  }, "Reply received"), /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 58,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#0076A6",
    textAnchor: "middle"
  }, "Coordinator sees inbox + Watch List"), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 0,
    width: 320,
    height: 80,
    rx: 12,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 0,
    width: 6,
    height: 80,
    rx: 3,
    fill: "#009391"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 34,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#005A58",
    textAnchor: "middle"
  }, "Coverage published"), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 58,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674",
    textAnchor: "middle"
  }, "Detected automatically or logged manually"), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 0,
    width: 320,
    height: 80,
    rx: 12,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 0,
    width: 6,
    height: 80,
    rx: 3,
    fill: "#92278F"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1420,
    y: 34,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#581756",
    textAnchor: "middle"
  }, "Wins recorded"), /*#__PURE__*/React.createElement("text", {
    x: 1420,
    y: 58,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73",
    textAnchor: "middle"
  }, "Placement logged, client notified"), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 40,
    x2: 456,
    y2: 40,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460,40 452,36 452,44",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 40,
    x2: 856,
    y2: 40,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "860,40 852,36 852,44",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 40,
    x2: 1256,
    y2: 40,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260,40 1252,36 1252,44",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 86,
    x2: 220,
    y2: 120,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 86,
    x2: 620,
    y2: 120,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 86,
    x2: 1020,
    y2: 120,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 86,
    x2: 1420,
    y2: 120,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 130,
    width: 320,
    height: 100,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#DCDEEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 158,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#152451",
    textAnchor: "middle",
    letterSpacing: 1
  }, "FILTERS AVAILABLE"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 182,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#5A5F73",
    textAnchor: "middle"
  }, "Awaiting \xB7 Replied \xB7 Placed"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 200,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#5A5F73",
    textAnchor: "middle"
  }, "Follow-up due \xB7 Dead"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 218,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontStyle: "italic",
    fill: "#727891",
    textAnchor: "middle"
  }, "Flag follow-ups, mark dead"), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 130,
    width: 320,
    height: 100,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#DCDEEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 158,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#152451",
    textAnchor: "middle",
    letterSpacing: 1
  }, "QUICK LOG"), /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 182,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#5A5F73",
    textAnchor: "middle"
  }, "Log response in one click"), /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 200,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#5A5F73",
    textAnchor: "middle"
  }, "Schedule follow-up"), /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 218,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontStyle: "italic",
    fill: "#727891",
    textAnchor: "middle"
  }, "Reporter CRM state updated"), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 130,
    width: 320,
    height: 100,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#DCDEEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 158,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#152451",
    textAnchor: "middle",
    letterSpacing: 1
  }, "PLACEMENT CAPTURE"), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 182,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#5A5F73",
    textAnchor: "middle"
  }, "URL + date + quote logged"), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 200,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#5A5F73",
    textAnchor: "middle"
  }, "Pitch flips to Placed"), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 218,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontStyle: "italic",
    fill: "#727891",
    textAnchor: "middle"
  }, "Goes to Placements ledger"), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 130,
    width: 320,
    height: 100,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#DCDEEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 1420,
    y: 158,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#152451",
    textAnchor: "middle",
    letterSpacing: 1
  }, "DOWNSTREAM EFFECTS"), /*#__PURE__*/React.createElement("text", {
    x: 1420,
    y: 182,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#5A5F73",
    textAnchor: "middle"
  }, "Win Story Feed updated"), /*#__PURE__*/React.createElement("text", {
    x: 1420,
    y: 200,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#5A5F73",
    textAnchor: "middle"
  }, "CEO sees it in real time"), /*#__PURE__*/React.createElement("text", {
    x: 1420,
    y: 218,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontStyle: "italic",
    fill: "#727891",
    textAnchor: "middle"
  }, "Reports view auto-updated"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,1900)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1604,
    height: 48,
    rx: 10,
    fill: "#F7F8E9",
    stroke: "#D2DA98",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 6,
    height: 48,
    rx: 3,
    fill: "#B0BC22"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 30,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#697114",
    letterSpacing: 1.5
  }, "PHASE 3  \xB7  END OF DAY  \xB7  REVIEW AND CLOSE OUT"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,1980)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 0,
    width: 380,
    height: 100,
    rx: 12,
    fill: "#F7F8E9",
    stroke: "#D2DA98",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 0,
    width: 6,
    height: 100,
    rx: 3,
    fill: "#B0BC22"
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 34,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#697114",
    textAnchor: "middle"
  }, "Review tomorrow's queue"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 58,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#697114",
    textAnchor: "middle"
  }, "Skim deferred items, set focus areas"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 80,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontStyle: "italic",
    fill: "#697114",
    textAnchor: "middle"
  }, "Prepares the agents for the morning run"), /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 0,
    width: 380,
    height: 100,
    rx: 12,
    fill: "#F7F8E9",
    stroke: "#D2DA98",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 0,
    width: 6,
    height: 100,
    rx: 3,
    fill: "#B0BC22"
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 34,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#697114",
    textAnchor: "middle"
  }, "Generate weekly reports"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 58,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#697114",
    textAnchor: "middle"
  }, "Per-client PDFs (auto-drafted, edit, export)"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 80,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontStyle: "italic",
    fill: "#697114",
    textAnchor: "middle"
  }, "CEO reviews same reports for client meetings"), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 0,
    width: 380,
    height: 100,
    rx: 12,
    fill: "#F7F8E9",
    stroke: "#D2DA98",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 0,
    width: 6,
    height: 100,
    rx: 3,
    fill: "#B0BC22"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1310,
    y: 34,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#697114",
    textAnchor: "middle"
  }, "Daily scan runs at 6 AM"), /*#__PURE__*/React.createElement("text", {
    x: 1310,
    y: 58,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#697114",
    textAnchor: "middle"
  }, "Tomorrow's Hot Board ready by 8 AM"), /*#__PURE__*/React.createElement("text", {
    x: 1310,
    y: 80,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontStyle: "italic",
    fill: "#697114",
    textAnchor: "middle"
  }, "The cycle starts again"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,2180)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 36,
    y2: 0,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36,0 30,-5 30,5",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 4,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#5A5F73"
  }, "Solid arrows = required step"), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 0,
    x2: 376,
    y2: 0,
    stroke: "#F58025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 384,
    y: 4,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#5A5F73"
  }, "Dashed = conditional / loops back to triage"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessFlow2);
export default __webpack_public_path__ + "static/media/process-flow2.15544d511344a8dcf711191604e7da9a.svg";
export { ForwardRef as ReactComponent };